import gql from 'graphql-tag'

export const SELF_QUERY = gql`
  {
    self {
      id
      contactCode
      firstName
      insertion
      lastName
      email
      phone
      altPhone
      permissions
      role
      gender
      branches {
        name
        address
        zipcode
        city
        servicePackage
        id
      }
    }
  }
`

export const CATEGORIES_QUERY = gql`
  {
    categories {
      id
      category
      description
      products {
        id
        productCode
        firstDescription
        packageUnit
        unit
        portalProduct
      }
    }
  }
`

export const PRODUCTS_QUERY = gql`
  {
    products {
      id
      productCode
      firstDescription
      packageUnit
      portalProduct
      packageAmount
      unit
      price
      category {
        category
      }
    }
  }
`

export const BRANCH_QUERY = gql`
  query BranchQuery($id: String!) {
    branch(id: $id) {
      id
      name
      phone
      altPhone
      email
      website
      address
      zipcode
      suspended
      city
      billingAddress
      billingZipcode
      billingCity
      accountNumber
      accountManager
      servicePackage
      nextDeliveryDate
      minimalOrderValue
      minimalOrderValueActive
      clientNumber
      orders {
        id
        submitted
      }
      portalOrders {
        id
        deliveryDate
        code
        submitted
        code
        deliveryNumber
      }
      deliveries {
        id
        deliveryDate
        code
        status
        submitted
        deliveryNumber
      }
      errorMessages {
        id
        machineNumber
        createdAt
      }
      contactMessages {
        id
        createdAt
      }
      invoices {
        id
        invoiceNumber
        invoiceDate
        expirationDate
        type
        amount
        balance
        term
        reminder
        complaint
        documents {
          id
          documentName
          documentDate
          documentNumber
        }
      }
      priceAgreements {
        id
        priceID
        productCode
        categoryCode
        price
        priority
        percentage
        minAmount
        validFrom
        validTill
      }
      docs {
        id
        type
        documentNumber
        documentDate
        documentName
      }
    }
  }
`

export const BRANCH_HISTORY_QUERY = gql`
  query BranchQuery($id: String!) {
    branch(id: $id) {
      id
      name
      servicePackage
      suspended
      oldOrders {
        id
        orderNumber
        deliveryDate
        # orderParts {
        #   amount
        #   product {
        #     category {
        #       category
        #     }
        #   }
        # }
      }
    }
  }
`

export const ORDER_QUERY = gql`
  query orderQuery($id: String!) {
    order(id: $id) {
      id
      submitted
      orderParts {
        id
        orderPartNumber
        note
        product {
          id
          productCode
          firstDescription
          packageUnit
          packageAmount
          unit
          price
          category {
            category
          }
        }
        amount
      }
      branch {
        servicePackage
      }
    }
  }
`

export const DELIVERY_QUERY = gql`
  query deliveryQuery($id: String!) {
    delivery(id: $id) {
      id
      submitted
      status
      code
      branch {
        servicePackage
      }
      orderParts {
        id
        orderPartNumber
        note
        product {
          id
          productCode
          firstDescription
          packageUnit
          packageAmount
          unit
          price
          category {
            category
          }
        }
        amount
      }
    }
  }
`

export const OLD_ORDER_QUERY = gql`
  query oldOrderQuery($id: String!) {
    oldOrder(id: $id) {
      id
      orderNumber
      deliveryDate
      branch {
        servicePackage
      }
      orderParts(where: {product: {id_not: null} }) {
        id
        orderPartNumber
        note
        product {
          id
          productCode
          firstDescription
          packageUnit
          packageAmount
          unit
          price
          category {
            category
          }
        }
        amount
      }
    }
  }
`

export const PORTAL_ORDER_QUERY = gql`
  query portalOrderQuery($id: String!) {
    portalOrder(id: $id) {
      id
      submitted
      status
      code
      clientReference
      deliveryNumber
      ociPlatform
      branch {
        servicePackage
        suspended
        priceAgreements {
          id
          priceID
          productCode
          categoryCode
          price
          percentage
          minAmount
          validFrom
          validTill
        }
      }
      orderParts {
        id
        orderPartNumber
        note
        product {
          id
          productCode
          firstDescription
          packageUnit
          packageAmount
          unit
          price
          btw
          category {
            category
          }
        }
        amount
      }
    }
  }
`

export const USER_BRANCH_QUERY = gql`
  query UserBranchQuery {
    self {
      id
      permissions
      role
      branches {
        id
        name
        servicePackage
        users {
          contactCode
          id
          gender
          firstName
          insertion
          lastName
          email
          phone
          altPhone
          permissions
          role
          username
          contactCode
          loginTimeStamp
        }
      }
    }
  }
`

export const USERNAME_QUERY = gql`
  query usernameExists($username: String!) {
    usernameExists(username: $username) {
      username
    }
  }
`

export const USER_QUERY = gql`
  query UserQuery($id: String!) {
    user(id: $id) {
      id
      gender
      firstName
      insertion
      lastName
      email
      phone
      altPhone
      permissions
      branches {
        id
        name
      }
    }
  }
`

export const DOWNLOAD_FILE = gql`
  query downloadFile($data: DownloadFileInput!) {
    downloadFile(data: $data)
  }
`



// WEBPACK FOOTER //
// ./src/queries.js